import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zimoney",
  "use": "icon-zimoney-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zimoney\"><path d=\"M630.3 867.9h329.2v-81.3H697.8c-18.7 30-41.4 57.4-67.5 81.3zM736.1 705.2h223.3v-81.3H753.9c-3 27.6-8.9 54.9-17.8 81.3zM753.9 542.5h205.6v-81.4H736.1c8.7 26.1 14.8 53.2 17.8 81.4zM630.2 298.4c26.1 23.9 48.8 51.3 67.5 81.4h261.7v-81.4H630.2zM349.3 135.7h610.2v81.4H349.3zM369.6 278.1c-168.5 0-305.1 136.6-305.1 305.1 0 168.5 136.6 305.1 305.1 305.1s305.1-136.6 305.1-305.1c0-168.5-136.6-305.1-305.1-305.1z m101.7 386.4H390v81.4h-40.7v-81.4h-81.4v-40.7h81.4v-40.7h-81.4v-40.7h61l-58.3-101 35.2-20.3 62.9 109 65.5-109.7 36.8 20.5-60.6 101.4h60.8V583H390v40.7h81.3v40.8z\" p-id=\"14179\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/zimoney.svg
// module id = bUkX
// module chunks = 12